// Validation library from: https://github.com/ruigomeseu/bitcoin-address-validation
// Copyright (c) 2018 Rui Gomes hello@ruigomes.me
import { base58_to_binary } from "base58-js";
import { createHash } from "sha256-uint8array";

const sha256 = (payload) => createHash().update(payload).digest();

let Network;
(function (Network) {
  Network["mainnet"] = "mainnet";
  Network["testnet"] = "testnet";
  Network["regtest"] = "regtest";
})(Network || (Network = {}));
let AddressType;
(function (AddressType) {
  AddressType["p2pkh"] = "p2pkh";
  AddressType["p2sh"] = "p2sh";
  AddressType["p2wpkh"] = "p2wpkh";
  AddressType["p2wsh"] = "p2wsh";
  AddressType["p2tr"] = "p2tr";
})(AddressType || (AddressType = {}));

const addressTypes = {
  0x30: {
    type: AddressType.p2pkh,
    network: Network.mainnet,
  },

  0x6f: {
    type: AddressType.p2pkh,
    network: Network.testnet,
  },

  0x32: {
    type: AddressType.p2sh,
    network: Network.mainnet,
  },

  0x3a: {
    type: AddressType.p2sh,
    network: Network.testnet,
  },
};

const getAddressInfo = (address) => {
  let decoded;
  const prefix = address.substr(0, 2).toLowerCase();

  if (prefix === "ltc" || prefix === "tltc") {
    // bech32 handling disabled
    throw new Error("bech32 not supported");
  }

  try {
    decoded = base58_to_binary(address);
  } catch (error) {
    throw new Error("Invalid address");
  }

  const { length } = decoded;

  if (length !== 25) {
    throw new Error("Invalid address");
  }

  const version = decoded[0];

  const checksum = decoded.slice(length - 4, length);
  const body = decoded.slice(0, length - 4);

  const expectedChecksum = sha256(sha256(body)).slice(0, 4);

  if (checksum.some((value, index) => value !== expectedChecksum[index])) {
    throw new Error("Invalid address");
  }

  const validVersions = Object.keys(addressTypes).map(Number);

  if (!validVersions.includes(version)) {
    throw new Error("Invalid address");
  }

  const addressType = addressTypes[version];

  return {
    ...addressType,
    address,
    bech32: false,
  };
};

const validate = (address, network) => {
  try {
    const addressInfo = getAddressInfo(address);

    if (network) {
      return network === addressInfo.network;
    }

    return true;
  } catch (error) {
    return false;
  }
};

export default validate;
